
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[slugOrId]",
      function () {
        return require("private-next-pages/event/[slugOrId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[slugOrId]"])
      });
    }
  